export var templateOptions = [
    { value: 'all', label: 'All Templates' },
    { value: 'solution', label: 'Solutions' },
    { value: 'concept', label: 'Concepts' },
    { value: 'function', label: 'Functions' },
    { value: 'legacy', label: 'Legacy Templates' },
];
